import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import * as eventsService from "../../../services/events.services";
import CustomPagination from "../../../common/custompagination";
import Sorting from "../../../common/sorting";
import Loader from "../../../common/loader";
import Breadcrums from "../../../common/breadcrumbs";
import $ from "jquery";
import {
  showFilterlist,
  INVITATION_STATUS,
} from "../../../../../utils/Constants";
import {
  formateDate
} from "../../../../../utils/commonfunction";
import StatusFilter from "../../../common/statusFilter";
import CustomRangepicker from "../../../common/rangepicker";

const InvitationsList = () => {
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const [statsupdate] = useState("false");
  const [serialno, setSerialNo] = useState("");
  const [datalength, setDataLength] = useState("");
  const [itemperpage] = useState(10);
  const [sorting, setSorting] = useState({});
  const [defaultSorting, setDefaultSorting] = useState(true);
  const [page, setPage] = useState(1);
  const [loader, setLoader] = useState(true);
  const [search, setSearch] = useState({});
  const [globalsearch, setGlobalSearch] = useState("");
  const breadcrumbs = [
    { title: "Dashboard", url: "/admin/dashboard" },
    { title: "Invitations", url: "" },
  ];
  const [resetdate, setResetDate] = useState(false);
  const [eventOptions, setEventOptions] = useState([]);
  const [filterEvent, setFilterEvent] = useState('');

  useEffect(() => {
    if (search) {
      setLoader(true);
      const formData = new FormData();
      formData.append("page", params.pgno);
      formData.append("per_page", itemperpage);
      formData.append("sort", JSON.stringify(sorting));
      formData.append("search", JSON.stringify(search));
      formData.append("global_search", globalsearch);
      if(filterEvent){
        formData.append("event_id", filterEvent);
      }
      eventsService
        .InvitationsList(formData)
        .then((data) => {
          console.log("data",data)
          setDataLength(data.data.total_records);
          setSerialNo(data.data.offset);
          setList(data && data.data && data.data.list ? data.data.list : []);
          setPage(data && data.data && data.data.page ? data.data.page : 1);
          setLoader(false);
        })
        .catch((error) => {
          console.log("error ====> ", error);
        });
    }
  }, [location, statsupdate, sorting, search, globalsearch,filterEvent,itemperpage,params.pgno]);

  useEffect(() => {
    eventsService.Options().then((response) => {
      console.log("response",response);
      setEventOptions(response?.data);
    }).catch((error) => {
      console.log("error",error);
    })
  },[])

  const viewfunction = (row) => {
    console.log("row",row)
    navigate(`/admin/event-management/invitations/view/${row._id}`);
  };

  // sorting function start
  const handleSort = (e, column) => {
    setDefaultSorting(false);
    let sort = { order: 0, column: column };
    if (e.target.classList.contains("assc")) {
      sort.order = -1;
    } else {
      sort.order = 1;
    }
    setSorting(sort);
  };
  // sorting end

  const getStatus = (status) => {
    if (status === INVITATION_STATUS.PENDING) {
      return <span className="badge badge-warning">Pending</span>;
    } else if (status === INVITATION_STATUS.ACCEPTED) {
      return <span className="badge badge-success">Accepted</span>;
    } else if (status === INVITATION_STATUS.REJECTED) {
      return <span className="badge badge-danger">Rejected</span>;
    }
  };

  // search or filter function
  const prepareSearch = (key, value) => {
    console.log("dtaaaa", key, value);
    let sr = { ...search };
    if (String(value).length > 0) {
      sr[key] = value;
    } else {
      delete sr[key];
    }
    setSearch(sr);
  };
  // search or filer end

  const resetFilter = (e) => {
    e.preventDefault();
    setGlobalSearch("");
    prepareSearch();
    setSearch({});
    // reset customrangepicker & customstatusfilter state using jquery//
    setResetDate(!resetdate);
    $("#defaultstatus")[0].selectedIndex = 0;
  };

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      {/* table section */}
      <div className="animation_fade">
        <div className="card custom-card">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h6 className="main-content-label">Invitations</h6>
              <div className="d-flex align-items-center">
                <div className="form-group mb-0 me-3">
                  <div className="form-group mb-0 rangepicker_container">
                    <i className="fa fa-search calender_icon"></i>
                    <input
                      type="search"
                      className="form-control"
                      value={globalsearch}
                      placeholder="Search"
                      onChange={(e) => {
                        setGlobalSearch(e.target.value);
                      }}
                    />
                  </div>
                </div>
                <div className="me-3">
                  <CustomRangepicker
                    GetDateRange={(e) => {
                      prepareSearch("createdAt", e);
                    }}
                    resetdate={resetdate}
                  />
                </div>
                <div className="me-3">
                  <StatusFilter
                    data={showFilterlist}
                    prepareSearch={prepareSearch}
                  />
                </div>
                <div className="form-group mb-0 filter_icon_container me-3">
                    <i className="fa fa-filter mr-2 filter_icon"></i>
                    <select className="form-control" onChange={(e) => setFilterEvent(e.target.value)} >
                      <option value={""}>
                        {"Select Event"}
                      </option>
                        {eventOptions && eventOptions.length > 0 && eventOptions.map((option, i) => {
                          console.log("option",option)
                            return (
                                <option key={i} value={option._id}>
                                    {option.title}
                                </option>
                            );
                        })}
                    </select>
                </div>
                <button
                  type="reset"
                  value="Reset"
                  onClick={resetFilter}
                  className="btn btn-warning float-right mr-2"
                >
                  Reset Filter
                </button>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table table-bordered border-t0 key-buttons text-nowrap w-100">
                <thead>
                  <tr>
                    <th className="sr_head">S.No</th>
                    <th>
                      <div className="sorting_column">
                        <span>Name</span>
                        <Sorting
                          sort={sorting}
                          handleSort={handleSort}
                          column="title"
                        />
                      </div>
                    </th>
                    <th>
                      <div className="sorting_column">
                        <span>Email</span>
                      </div>
                    </th>
                    <th>
                      <div>
                        <span>Event</span>
                      </div>
                    </th>
                    <th>
                      <div className="sorting_column">
                        <span>Created Date</span>
                        <Sorting
                          sort={sorting}
                          handleSort={handleSort}
                          defaultSorting={defaultSorting}
                          column="createdAt"
                        />
                      </div>
                    </th>
                    <th className="status_head">Status</th>
                    <th className="action_head">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {loader ? (
                    <tr>
                      <td colSpan={7}>
                        <Loader />
                      </td>
                    </tr>
                  ) : (
                    <>
                      {list.length ? (
                        list.map((row, i) => {
                          console.log("row?.status",row?.status);
                          return (
                            <tr key={i}>
                              <td>{serialno + (i + 1)}</td>
                              <td>{row.name ? row.name : "N/A"}</td>
                              <td>
                                {row.email
                                  ? row.email
                                  : "N/A"}
                              </td>
                              <td>
                                {row.event_data.title
                                  ? row.event_data.title
                                  : "N/A"}
                              </td>
                              <td>
                                {row.createdAt
                                  ? formateDate(row.createdAt)
                                  : "N/A"}
                              </td> 
                              <td>{getStatus(row?.status)}</td>

                              <td>
                                <div className="d-flex">
                                  <button
                                    className="btn ripple btn-main-primary signbtn"
                                    onClick={() => {
                                      viewfunction(row);
                                    }}
                                  >
                                    View
                                  </button>
                                </div>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan={7} className="text-center">
                            No records
                          </td>
                        </tr>
                      )}
                    </>
                  )}
                </tbody>
              </table>
            </div>
            <div
              className=""
              id="example1_info"
              role="status"
              aria-live="polite"
            >
              <b>Total Records : {datalength ? datalength : "0"}</b>
            </div>
            {datalength && datalength > 0 ? (
              <CustomPagination
                datalength={datalength}
                itemperpage={itemperpage}
                currentPage={page}
                setPage={setPage}
                pageRoute={[
                  {
                    name: "Invitations",
                    path: "/admin/event-management/invitations/list",
                  },
                ]}
              />
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default InvitationsList;
